import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { getParams } from '../common/utils';
import { entityTypes, repiActions } from '../../store/repiStore';
import { popupActions } from '../../store/popupStore';
import { SECTIONS, reportActions } from '../../store/reportStore';
import { hasConsentInStorage, reportUrlChanged } from './repiUtils';
import { isNullOrUndefined, isString, getRepiSetting } from '../../store/storeFunctions';
import Message from '../common/message';
import RepiFooter from './repiFooter';
import ReportSection from '../common/reportSection';
import ReportExpander from '../common/reportExpander';

class RepiReport extends React.Component {
    state = { reloaded: false };

    get sharingAllowed() { return getRepiSetting("allowSharing", false); }

    get reportDate() {
        const params = getParams(window.location.search);
        return this.props.convertDate(params.calculationDate, new Date());
    }

    get hasConsent() {
        if (!this.props.isPlus() || this.props.isDataCorrection() || this.props.isSubject())
            return true;

        if (this.props.entityType === entityTypes.po)
            return true;

        return this.props.consent === true || hasConsentInStorage(this.props.getRepiProps().subjectId);
    }

    render() {
        if (!this.hasConsent) {
            return (
                <div className="card" style={{ marginTop: "1em", width: "95%" }}>
                    <Message type="warning" message={this.props.translate("Repi.Error.CheckReport.NoAccess")} />
                </div>
            );
        }
        var sectionsWithData = null;
        if(!isNullOrUndefined(this.props.sections)) 
            sectionsWithData = this.props.sections.filter(s => !s.hidden && s.hasData)

        return (
            <React.Fragment>
                <ReportExpander allowExpandAll={false} allowSectionSelector={false} reportDate={this.reportDate} />
                {this.renderSections()}
                {(!isNullOrUndefined(sectionsWithData) && sectionsWithData.length <= 1 ) && this.renderError()}
                <RepiFooter />
            </React.Fragment>
        );
    };

    componentDidMount() {
        this.props.cancelReportReload();
        if (this.hasConsent)
            this.loadReportSettings(true);
    };

    componentDidUpdate(prevProps) {
        if (!this.hasConsent)
            return;

        if (this.props.userLaguage !== prevProps.userLaguage)
            this.loadReportSettings(true);

        const searchParams = getParams(window.location.search);
        if (this.props.requestedReload === false && this.state.reloaded)
            this.setState({ reloaded: false });

        if (this.props.requestedReload === true && !this.state.reloaded) {
            this.loadReportSettings();
            this.setState({ reloaded: true });
        } else if (reportUrlChanged(prevProps, this.props)) {
            // For redirects from Cribis search do not reload report on url change, else 2 requests would be made
            if (!(searchParams.source === "cribis" && !isNullOrUndefined(prevProps.location) && !prevProps.location.startsWith("/repi"))) {
                this.loadReportSettings(true);
            }
        } else if (!isNullOrUndefined(this.props.sections)) {
            const s = this.props.sections.find(f => f.id === SECTIONS.repiReportPaymentHistory  || f.id === SECTIONS.repiITrade);
            if (!isNullOrUndefined(s) && !isNullOrUndefined(s.params) && !isNullOrUndefined(s.params.calculationDate)) {
                if (isString(searchParams.calculationDate) && isString(s.params.calculationDate)) {
                    const dateParams = this.props.convertDate(searchParams.calculationDate, null, "YYYY-MM-DD");
                    const dateSection = this.props.convertDate(s.params.calculationDate, null, "YYYY-MM-DD");
                    if (dateParams !== dateSection)
                        this.loadReportSettings(true);
                }
            }
        }
    };

    componentWillUnmount() {
        this.props.onLeavingReport();
        if (this.props.sections)
            this.props.restoreConfig();
    };

    renderSections = () => {
        if (isNullOrUndefined(this.props.sections))
            return null;

        return (
            this.props.sections.filter(s => !s.hidden).map(s => <ReportSection
                key={s.id + '-' + s.orderId}
                sectionId={s.id}
                refreshButton={[SECTIONS.repiPaymentHistoryDataCorrection, "RepiSubjectDataCorrection"].includes(s.id)}
            />)
        );
    };

    loadReportSettings = (forceReload = false) => {
        const { subjectId, reportType } = this.props.getRepiProps();
        const params = this.getParamsForReportSettings();
        this.props.requestGetRepiReportSettings(subjectId, reportType, window.location, params, forceReload);
    }

    getParamsForReportSettings = () => {
        let params = getParams(window.location.search);
        const reqParams = {
            sharedRegistry: isNullOrUndefined(params.sharedRegistry) ? false : this.sharingAllowed && params.sharedRegistry === "true",
            calculationDate: moment(this.reportDate).format("YYYY-MM-DD"),
            url: window.location
        };

        if (!isNullOrUndefined(params.poolGroup))
            reqParams.poolGroup = parseInt(params.poolGroup);

        return reqParams;
    }

    renderError = () => {
        return (
            <div className='report-nodata'>
                <Message type="warning" message={this.props.translate("Repi.Report.NoHit.Message")} />
            </div>
        );
    }
}

export default withLocalize(withRouter(connect(
    state => ({ userLaguage: state.userContext.language, ...state.report, ...state.repi.search }),
    dispatch => bindActionCreators({...reportActions, ...repiActions, ...popupActions}, dispatch)
)(RepiReport)));
